import { Customer } from '@/types'
import { customerLabel } from '@/utils/format'
import { ActionIcon, Group, Loader, Select } from '@mantine/core'
import { IconPlus } from '@tabler/icons-react'

export default function CustomerPicker({
  customers,
  searchValue,
  onSearchChange,
  onCustomerSelect,
  onNewCustomerClick,
  isLoading,
  disabled,
}: {
  customers: Customer[]
  searchValue: string
  onSearchChange: (value: string) => void
  onCustomerSelect: (customer: Customer) => void
  onNewCustomerClick: () => void
  isLoading?: boolean
  disabled?: boolean
}) {
  const handleSelectChange = (value: string | null) => {
    if (!value) return
    const customer = customers.find((candidate) => candidate.id === Number(value))
    if (customer) onCustomerSelect(customer)
  }

  return (
    <Group gap="xs" wrap="nowrap" align="flex-start">
      <Select
        flex={1}
        placeholder="Nom ou téléphone..."
        data={customers.map((customer) => ({ value: String(customer.id), label: customerLabel(customer) }))}
        searchValue={searchValue}
        onSearchChange={onSearchChange}
        onChange={handleSelectChange}
        searchable
        disabled={disabled}
        rightSection={isLoading ? <Loader size="xs" /> : undefined}
        nothingFoundMessage="Aucun client trouvé"
        filter={({ options }) => options}
        data-autofocus
      />
      <ActionIcon
        size="lg"
        variant="light"
        onClick={onNewCustomerClick}
        aria-label="Nouveau client"
      >
        <IconPlus size={18} />
      </ActionIcon>
    </Group>
  )
}
